import React, { useState } from "react";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  message,
  Tabs,
  Spin,
  Upload,
  Breadcrumb,
  Popconfirm
} from "antd";
import PersonalDetails from "./personal-details";
import { useNavigator } from "../../utilities/navigation";
import { useQuery, useQueryClient, useMutation } from 'react-query'
import { utilities } from "../../utilities/utlities";
import "./styles.css";
import { UserRegistrationUpdate } from "../profile/api";
import { profileTabconfig } from "../../configurations/profileTab";
import { profileconfig} from "../../configurations/profileconfig";
import { Link, useParams } from 'react-router-dom';
import { CheckCircleFilled, CloseCircleFilled,WarningFilled } from '@ant-design/icons'
import RejectionCommnetsDrawer from './RejectionCommentsDrawer'
import { UserProfile } from './api'

export default function ViewProfile() {
  const [navigator] = useNavigator()
  const { Content } = Layout
  const { TabPane } = Tabs;
  const loginUser = utilities.loggedUser();
  const client = useQueryClient()
  const [data, setData] = useState()
  const [id, setId] = useState(null)
  const { Text, Title } = Typography
  const [userType, setUserType] = useState('')
  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const parameters = useParams();
  const [selectedField, setSelectedField] = useState(null)
  const [comment, setComment] = useState('')
  const [objectDetails, setObjectDetails] = useState([])
  const [selected, setSelected] = useState([])
  const [loader, setLoading] = useState(false)
  const [userProfileTabs,setUserProfileTabs] = useState([])
  var counter = 0
  const [objectionKey,setobjectionKey] = useState([])
  const [resize,setResize] = useState(document?.documentElement?.clientWidth)

  window.addEventListener("resize", ()=>{

    // alert(document?.documentElement?.clientWidth)
    setResize(document?.documentElement?.clientWidth)
});

  const mutation = useMutation(async (Target) => {
    const response = await UserProfile.addRejection(Target)
    return { ...response, delete: Target?.delete,key:Target?.key }
  },
    {
      onError: (error, variables, context) => {
        message.error(error.message, 3)
        setLoading(false)
      },
      onSuccess: (data, variables, context) => {
        setLoading(false)
        if (data?.delete == true) {
          message.success("Rejection Deleted Successfully", 3)
          const deleteComment = objectDetails?.filter((item) => item?.title != data?.key)
          setObjectDetails(deleteComment)
          setSelectedField(null)
        } else {
          message.success("Rejection added Successfully", 3)
          setObjectDetails([...objectDetails,
          {
            key: counter + 1,
            title: selectedField,
            comment: comment,
          },
          ])

          setSelectedField(null)
          setComment('')
        }
      }
    }
  )

  const {mutateAsync:userApproval,isLoading:UserApprovalLoading} = useMutation(async (Target) => {
    const response = await UserProfile.approvedUser(Target)
    return { ...response,type:Target?.type }
  },
    {
      onError: (error, variables, context) => {
        closeDialog()
      },
      onSuccess: (data, variables, context) => {
        closeDialog()
        if(data?.type == true){
        message.success("User is successfully Approved",3)
        }
        else{
          message.success("Rejection send successfully",3)
        }
      }
    }
  )

  const addRejection = (data) => {
    mutation.mutateAsync({ id: parameters?.id })
  }

  const ongetSuccess = (data) => {
    getUser(data.data)
  }
  const ongetError = (err) => {
    message.error(err.message, 3)
  }

  const selectFields = (key, value) => {
    if (key == "comment") {
      setComment(value)
    }
    else {
      setSelectedField(value)
    }

  }
  const addComment = () => {

    mutation.mutateAsync({
      id: parameters?.id,
      objection: {				// for adding,updating,deleting objection
        key: selectedField,
        comment: comment,
        delete: false          //incase of removing objection
      },
      user: userType,
      token: loginUser?.jwtToken,
      delete: false
    })
    setLoading(true)
  }
  const closeDialog = () => {
    setVisible(false)
  }
  const deleteComment = (key) => {
    const selectedComment = objectDetails?.filter((item) => item?.title == key)
    setSelectedField(key)
    mutation.mutateAsync({
      id: parameters?.id,
      objection: {				// for adding,updating,deleting objection
        key: selectedComment[0]?.title,
        comment: selectedComment[0]?.comment,
        delete: true          //incase of removing objection
      },
      user: userType,
      token: loginUser?.jwtToken,
      delete: true,
      key: key


    })

  }
  const editComment = (key, value) => {
    const deleteComment = objectDetails?.filter((item) => item?.title != key)
    setObjectDetails(deleteComment)
    setSelectedField(key)
    setComment(value)

  }
  const { isLoading, refetch } = useQuery(['profileView', loginUser], async () => {
    return await UserRegistrationUpdate.fetchUserData(loginUser?.jwtToken)
  }, {
    enabled: false,
    onSuccess: ongetSuccess,
    onError: ongetError,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60

  })
  const { isLoading: loadinForAdmin, refetch: fetchingForAdmin } = useQuery(['profileView', { id: parameters?.id, user: loginUser }], async () => {
    return await UserRegistrationUpdate.getUerForAdmin({ id: parameters?.id, user: loginUser })
  }, {
    enabled: false,
    onSuccess: ongetSuccess,
    onError: ongetError,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60

  })


  const getUser = async (data) => {
    console.log(data)
    setUserType(data?.user?.type)
    var tabsData = profileTabconfig?.[data?.user?.type]?.fields
    console.log(tabsData)
    console.log(data?.company?.objections)
     if(data?.company?.objections != undefined){
     var objectionKeys = data?.company?.objections?.map(item=>item?.key)
     if(loginUser?.type != 'admin'){
    Object.keys(profileconfig?.[data?.user?.type])?.map(item=>{
      profileconfig?.[data?.user?.type]?.[item]?.fields?.map(fields=>{
        console.log(objectionKeys)
        if(objectionKeys.includes(fields?.label2)){
          const currentElementIndex = tabsData.findIndex(tab=> item ==  tab.number)
          var objectFilter = tabsData?.find(tab=> item ==  tab.number)
          objectFilter = {...objectFilter,warning:true}
          if(objectFilter.hasOwnProperty('warning')){
            tabsData.splice(currentElementIndex , 1)
            tabsData.splice(currentElementIndex , 0,objectFilter)
          }
          else{
            tabsData.splice(currentElementIndex , 0,objectFilter)
          }
      }
      })

      
    })
    setobjectionKey(objectionKeys)
  }
}
  console.log(tabsData)
    setUserProfileTabs(tabsData)
    if(data?.company?.objections != undefined){
    const objections = data?.company?.objections.map(item => {
      return {
        key: counter + 1,
        title: item?.key,
        comment: item?.comment,
      }
    })
    setObjectDetails(objections)
  }
  
    const datapoint = []
    Object.keys(profileconfig?.[data?.user?.type])?.map(item => {
      profileconfig?.[data?.user?.type]?.[item]?.fields?.map(item => {
        if (item.name != undefined && item.type != "button") {
          datapoint.push({
            label: item.label2,
            value: item.label2
          })
        }
      })
    })
    setSelected(datapoint)

    var userdata = {
      firstName: data?.user?.firstName,
      lastName: data?.user?.lastName,
      mobileNumber: data?.user?.[data?.user?.type]?.mobileNumber || data?.user?.[data?.user?.type]?.telephoneNumber,
      jobTitle: data?.user?.[data?.user?.type]?.jobTitle,
      department: data?.user?.[data?.user?.type]?.department,
      comapnyname: data?.company?.companyName,
      numberofEmployee: data?.company?.numberOfEmployees,
      companyWebsite: data?.company?.companyWebsite,
      compnayPhone: data?.company?.phoneNumber,
      country: data?.company?.location?.country,
      city: data?.company?.location?.city,
      street: data?.company?.location?.street,
      postalcode: data?.company?.location?.postCode,
      firstName_billing: data?.company?.billingPerson?.firstName,
      lastName_billing: data?.company?.billingPerson?.lastName,
      email_billing: data?.company?.billingPerson?.email,
      jobTitle_billing: data?.company?.billingPerson?.jobTitle,
      department_billing: data?.company?.billingPerson?.department,
      phone_billing: data?.company?.billingPerson?.mobileNumber,
      linkedIn_billing: data?.company?.billingPerson?.linkedInProfile,


      firstName_authorized: data?.company?.authorizedSignatory?.firstName || data?.company?.invoicePerson?.firstName,
      lastName_authorized: data?.company?.authorizedSignatory?.lastName || data?.company?.invoicePerson?.surname,
      email_authorized: data?.company?.authorizedSignatory?.email || data?.company?.invoicePerson?.email,
      jobTitle_authorized: data?.company?.authorizedSignatory?.jobTitle || data?.company?.invoicePerson?.jobTitle,
      departmant_authorized: data?.company?.authorizedSignatory?.department || data?.company?.invoicePerson?.department,
      phone_authorized: data?.company?.authorizedSignatory?.phone || data?.company?.invoicePerson?.telephoneNumber,
      linkedIn_authorized: data?.company?.authorizedSignatory?.linkedInProfile,
      invoicePersonCountry: data?.company?.invoicePerson?.country,
      personPostal: data?.company?.invoicePerson?.postCode,

      surname: data?.user?.[data?.user?.type]?.surname,
      title: data?.user?.[data?.user?.type]?.title,
      vatcountry: data?.company?.vatCountry,
      Vatnumber: data?.company?.vatNumber,
      registrationNumber: data?.company?.registrationNumber,
      gmpCertficate: {
        name: data?.company?.documents?.gmpCertficate?.split('-key-')[1],
        url: data?.company?.documents?.gmpCertficate
      },
      tradeLicense: {
        name:
          data?.company?.documents?.tradeLicense?.split('-key-')[1],
        url: data?.company?.documents?.tradeLicense
      },
      trnCertificate: {
        name:
          data?.company?.documents?.trnCertificate?.split('-key-')[1],
        url: data?.company?.documents?.trnCertificate
      },

      manufacturingLicense: {
        name: data?.company?.documents?.manufacturingLicense?.split('-key-')[1],
        url: data?.company?.documents?.manufacturingLicense
      },
      siteMasterFile: {
        name: data?.company?.documents?.siteMasterFile?.split('-key-')[1],
        url: data?.company?.documents?.siteMasterFile
      },
      detailedCompanyProfile: {
        name: data?.company?.documents?.detailedCompanyProfile?.split('-key-')[1],
        url: data?.company?.documents?.detailedCompanyProfile
      },
      listOfManufacturedMedicinces: {
        name: data?.company?.documents?.listOfManufacturedMedicinces?.split('-key-')[1],
        url: data?.company?.documents?.listOfManufacturedMedicinces
      },
      certificatesOfGoodManufacturingPractices: {
        name: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0].split('-key-')[1] : undefined,
        url: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0] : undefined
      },
      certificatesOfRegistration: {
        name: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0].split('-key-')[1] : undefined,
        url: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0] : undefined
      }

    }
    setData(userdata)
  }

  const approveUser = (key)=>{
    userApproval({
      key:key,
      id:parameters?.id,
      token:loginUser?.jwtToken
    })
  }


  React.useEffect(() => {
    if (loginUser != null) {
      if (client.getQueryData('profileView') != undefined) {
        return client.getQueryData('profileView')?.data
      } else {
        if (parameters?.id != null && parameters?.id != undefined) {
          fetchingForAdmin()
        }
        else {
          if (loginUser?.type == "admin") {
            navigator('/admin/dashboard')
          } else {
            refetch()
          }
        }
      }
    }
  }
    , [])

  return (
    <Layout className="layout">
      <>
        <RejectionCommnetsDrawer visible={visible} selectFields={selectFields}
          objectDetails={objectDetails}
          addComment={addComment}
          selectedField={selectedField}
          comment={comment}
          selected={selected}
          deleteComment={deleteComment}
          editComment={editComment}
          closeDialog={closeDialog}
          addRejection={addRejection}
          loading={mutation.isLoading}
          // selectedField={selectedField}
          loader={loader}
          approveUser={approveUser}
        />
        <Content className={`${isLoading == true || loadinForAdmin == true ? 'loading-content' : ''}`}>
          {isLoading == true || loadinForAdmin == true ?
            <Spin size="large" tip="Please Wait..." />
            :
            <>
              {loginUser?.type == "admin" ?
                <div className="user-name-title-container">
                  <div className="user-name-title">
                    <Title className="username">
                      {data?.firstName +' ' + data?.lastName}
                    </Title>
                    <Breadcrumb>
                      <Breadcrumb.Item>
                        <Link to ={`/profiles/${userType}`}>{userType?.toUpperCase()}</Link>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item>
                        <Text>{data?.firstName +' ' + data?.lastName}</Text>
                      </Breadcrumb.Item>
                    </Breadcrumb>

                  </div>
                  {/* {loginUser?.type == "admin" ? */}
                  <div className="admin-action"><Button danger onClick={() => {
                    setVisible(true)
                  }}><CloseCircleFilled /> Reject</Button>
                    <Popconfirm
                      placement="bottomRight"
                      title={`Do you really want to Approve ${data?.firstName} ${data?.lastName} profile?`}
                      onConfirm={() => {approveUser(true) }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="primary" onClick={()=>{
                        
                      }}
                      loading={UserApprovalLoading}
                      ><CheckCircleFilled /> Accept</Button>
                    </Popconfirm>
                  </div>
                  {/* :null */}
                  {/* } */}
                </div> : <div className="user-name-title-container">
                  <div className="user-name-title">
                    <Title className="username">
                      My Profile
                    </Title>
                  </div>
                  <Button type="primary" onClick={() => {
                    navigator('/profile/edit')
                  }}>Edit</Button>
                </div>}
              <div className="site-layout-content profileViewContainer">
                <Tabs tabPosition={resize > 700 ? 'left':'top'} className="userProfileTab">
                  {userProfileTabs?.map((item) => {
                    const label = <span className="tabLabel">{item.label}  {item?.warning == true ? <WarningFilled className="tabsWarning" />:null}</span>
                    return <TabPane tab={label} key={item.key}>
                      <PersonalDetails 
                      objectionKey = {objectionKey}
                      data={data}
                       tabNumber={item.number} loginUser={loginUser} userType={userType} />
                    </TabPane>
                  })

                  }
                </Tabs>
              </div>
            </>
          }
        </Content>
      </>
    </Layout>
  )
}
